e4.nav.global.bindEvents = function () {
    var jNav = jQuery( '.js-e-nav' ),
        jHeader = jQuery( '.js-e-header' ),
        jNavToggle = jQuery( '.js-e-nav-toggle' );
    jNavToggle.on( 'click', function ( event ) {
        event.preventDefault();
        event.stopPropagation();
        jNav.modal( 'toggle' );
    } );
    jNav.on( 'swipeleft', function () {
        jNav.modal( 'hide' );
    } ).on( 'show.bs.modal', function () {
        jHeader.addClass( 'reset-transform-containing-block navbar-open' );
    } ).on( 'hide.bs.modal', function () {
        jHeader.removeClass( 'reset-transform-containing-block navbar-open' );
    } ).on( 'shown.bs.modal', e4.nav.global.revealActivePath ).on( 'hidden.bs.modal', e4.nav.global.resetActivePath ).on( 'click', 'a', e4.nav.global.toggleCollapseAndDropdown );
};



var olinoCaps = olinoCaps || {};
( function () {
    'use strict';
    jQuery( function () {
        if(jQuery('.js-olino-cap-configurator').length > 0){
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                olinoCaps.validationRules.bind();
            });
            olinoCaps.configurator.init();
        }
        if(jQuery('.js-olino-institution').length > 0){
            olinoCaps.institution.init();
        }
        //olinoCaps.institution.jInstitutionSearchWrapper
    } );

    olinoCaps.configurator = {
        accordionAnimationSpeed: 350,
        jConfiguratorContainer: null,
        init: function(){
            olinoCaps.configurator.jConfiguratorContainer = jQuery('.js-olino-cap-configurator');
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-schoolname-options' );
                olinoCaps.configurator.bindEvents();
            } );
        },
        bindEvents: function(){
            olinoCaps.configurator.jConfiguratorContainer.on('keypress', '.js-validate-embroidery', function(event){
                return /[AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZzÆæØøÅåÄäÖöÜüββÁáÉéÓóÍíÚúÝýÑñ&\-.,_/ ]/i.test(event.key);
            });

            olinoCaps.configurator.jConfiguratorContainer.on('change', '#EcomOrderLineFieldInput_OrderlineCapSize0', function(event){
                e4.product.variants.updateBreadcrumb();
            });

            olinoCaps.configurator.jConfiguratorContainer.on('change', '.js-olino-cap-accordion-radio', function(event){
                jQuery(jQuery(event.currentTarget).data('target')).collapse('show');
            });

            olinoCaps.configurator.jConfiguratorContainer.on('change', '.js-olino-cap-accordion-checkbox', function(event){
                var jElement = jQuery(event.currentTarget);
                if(jElement.prop('checked')){
                    jQuery(jElement.data('target')).collapse('show');
                    jElement.closest('.js-olino-relatedproducts-group').find('.js-olino-relatedproducts-group-input').eq(0).prop('checked', true).trigger('change');
                } else {
                    jQuery(jQuery(event.currentTarget).data('target')).collapse('hide');
                    setTimeout(function(){
                        jElement.closest('.js-olino-relatedproducts-group').find('.js-olino-relatedproducts-group-input').prop('checked', false).trigger('change');
                    }, olinoCaps.configurator.accordionAnimationSpeed);
                }
            });

            olinoCaps.configurator.jConfiguratorContainer.on('change', '.js-cap-olino-product-form-variant-group-input', function(event){
                var jElement = jQuery(event.currentTarget);
                if(jElement.data('distinct') !== undefined){
                    olinoCaps.configurator.filterRelatedGroups(event);
                }
            });

            olinoCaps.configurator.jConfiguratorContainer.on('hidden.bs.collapse', '.collapse', function (event) {
                olinoCaps.configurator.setDefaultVariant(event);
                olinoCaps.configurator.setDefaultOrderlineFieldValue(event);

                if(jQuery(event.currentTarget).find('.js-olino-cap-school-userid').length > 0){
                    olinoCaps.institution.jInstitutionSearchWrapper.find( '.js-olino-schoolname-options' ).html('');
                    olinoCaps.institution.jInstitutionSearchWrapper.find('.js-olino-delete-deselect-school').trigger('click');
                }
            });
            olinoCaps.configurator.update();
        },
        update: function(){
            olinoCaps.configurator.jConfiguratorContainer.find('.js-e-product-form-variant-group-input:checked').each(function(intIndex, domElement){
                var jElement = jQuery(domElement),
                    jWrapper = jElement.closest('.js-olino-cap-variant-group-wrapper');
                if(jWrapper.length > 0){
                    if(jElement.val() !== jWrapper.find('.js-olino-product-form-variant-form-group').data('defaultVariantOption')){
                        jWrapper.find('.js-olino-cap-accordion-checkbox').not(':checked').prop('checked', true).trigger('change');
                    }
                }
                jElement.trigger('change');
            });
        },
        filterRelatedGroups: function(event){
            var jElement = jQuery(event.currentTarget),
                dataDistinct = jElement.data('distinct');
            olinoCaps.configurator.jConfiguratorContainer.find('.js-olino-relatedproducts-group').each(function(intIndex, domElement) {
                var jElement = jQuery( domElement ),
                    relatedGroupName = jElement.data( 'relatedGroupName' );
                if ( relatedGroupName.indexOf( 'Distinct' ) > -1 ){
                    if ( relatedGroupName.indexOf( dataDistinct ) > -1 ) {
                        olinoCaps.configurator.showAndSelectRelatedGroup(jElement);
                    } else {
                        olinoCaps.configurator.hideAndDeselectRelatedGroup(jElement);
                    }
                }
            });
        },
        showAndSelectRelatedGroup: function(jElement){
            jElement.show();
        },
        hideAndDeselectRelatedGroup: function(jElement){
            jElement.hide();
            jElement.find('.js-olino-cap-accordion-checkbox:checked').prop('checked', false).trigger('change');
            setTimeout(function(){
                jElement.find('.js-olino-relatedproducts-group-input:checked').prop('checked', false).trigger('change');
            }, olinoCaps.configurator.accordionAnimationSpeed);
        },
        setDefaultOrderlineFieldValue: function(event){
            var jWrapper = jQuery(event.currentTarget);
            jWrapper.find('[data-orderline-field-default-value]').each(function(intIndex, domElement){
                var jElement = jQuery(domElement);
                jElement.val(jElement.data('orderlineFieldDefaultValue'));
            });
        },
        setDefaultVariant: function(event){
            var jWrapper = jQuery(event.currentTarget).closest('.js-olino-cap-variant-group-wrapper'),
                defaultVariantValue = jWrapper.find('.js-olino-product-form-variant-form-group').data('defaultVariantOption');
            if(defaultVariantValue !== undefined){
                jWrapper.find('.js-e-product-form-variant-group-input[value="'+defaultVariantValue+'"]').prop('checked', true).trigger('change');
            }
        }
    };

    olinoCaps.institution = {
        jInstitutionSearchWrapper: null,
        education: null,
        init: function(){
            e4.require.js( e4.settings.require.typeahead, function () {
                olinoCaps.institution.jInstitutionSearchWrapper = jQuery( '.js-olino-institution' );
                olinoCaps.institution.education = olinoCaps.institution.jInstitutionSearchWrapper.find('.js-olino-schoolname-input').data('education');
                olinoCaps.institution.bindEvents();
            });
        },
        bindEvents: function(){

            olinoCaps.institution.jInstitutionSearchWrapper.on('click', '.js-olino-delete-deselect-school', function(event){
                olinoCaps.institution.jInstitutionSearchWrapper.find('.js-olino-embroidery-schoolname-container').addClass('d-none');
                olinoCaps.institution.jInstitutionSearchWrapper.find('.js-olino-embroidery-schoolname').text('');
                olinoCaps.institution.jInstitutionSearchWrapper.find('#EcomOrderLineFieldInput_OrderLineEmbroiderySchoolName0').val('');
                jQuery('.js-olino-cap-school-userid').val('');
            });

            olinoCaps.institution.jInstitutionSearchWrapper.on('change', '.js-olino-schoolname-selector', function(event){
                var jElement = jQuery(event.currentTarget);
                olinoCaps.institution.jInstitutionSearchWrapper.find( '.js-olino-schoolname-options' ).html('');
                olinoCaps.institution.setSchoolNameForEmbroidery(jElement.data('userid'), jElement.val());
            });

            olinoCaps.institution.jInstitutionSearchWrapper.find('.js-olino-schoolname-input').on( 'keydown', function ( event ) {
                jQuery('.js-olino-cap-school-userid').val('');
                jQuery('.educations-delivery-validation').val('');
                if ( event.keyCode === 13 ) {
                    event.preventDefault();
                    var jSuggestions = jQuery( event.target.form ).find( '.js-olino-institutions-suggestions' ),
                        jSuggestionActive = jSuggestions.find( '.tt-selectable' ).filter( '.active' );
                    if ( jSuggestionActive.length === 0 && jSuggestions.css( 'display' ) === 'block' ) {
                        jQuery( this.form ).triggerHandler( 'submit' );
                    }
                }
            } ).typeahead( {
                hint: true,
                highlight: true,
                minLength: 0,
                classNames: {
                    wrapper: 'olino-institution-typeahead-wrapper d-flex js-olino-institution-typeahead-wrapper w-100',
                    input: 'js-olino-institution-input olino-institution-input',
                    menu: 'js-olino-institutions-suggestions olino-institution-suggestions dropdown-menu w-100',
                    suggestion: 'js-olino-institutions-suggestions-item dropdown-item',
                    open: 'open',
                    cursor: 'active',
                    highlight: 'active'
                }
            }, {
                name: 'espresso',
                display: function ( suggestion ) {
                    return suggestion.company +', '+suggestion.address +', '+ suggestion.zip +' '+ suggestion.city +', '+suggestion.department;
                },
                limit: 20,
                async: true,
                source: e4.util.debounce(function ( query, syncResults, asyncResults ) {
                    olinoCaps.institution.getSuggestions( query, olinoCaps.institution.education, function ( institutions ) {
                        asyncResults( institutions );
                    } );
                }, e4.settings.debounceDelay.input )
            } ).on( 'typeahead:autocomplete typeahead:select', function ( event, institution ) { // typeahead:cursorchange
                if ( institution !== null ) {
                    olinoCaps.institution.insertInstitution( institution );
                    jQuery( this ).typeahead( 'close' );
                }
            } );
        },
        getSuggestions: function ( query, education, asyncResults ) {
            if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                this.jqXHR.abort();
            }
            query = jQuery.trim( query );
            if ( query !== '' ) {
                this.jqXHR = jQuery.ajax( {
                    method: 'GET',
                    url: e4.settings.institutions.url,
                    data: {
                        q: query,
                        education: education
                    },
                    dataType: 'json'
                } );
                this.jqXHR.done( function ( data ) {
                    asyncResults( data.users );
                } );
            }
        },
        focus: function () {
            var jInstitution = jQuery( '.js-olino-institution' ),
                intTarget = Math.ceil( jInstitution.offset().top - jQuery( window ).height() + jInstitution.height() + e4.scrollToAnchor.getNudge() );
            e4.scrollToAnchor.animate( intTarget, function () {
                if ( jQuery( document.activeElement ).is( '.js-e-orderline-quantity-input' ) !== true ) {
                    jInstitution.find( '.js-olino-institution-input' ).focus();
                }
            } );
        },
        clear: function () {
            jQuery( '.js-olino-institution-input' ).typeahead( 'val', '' );
        },
        insertInstitution: function ( objInstitution ) {
            if(olinoCaps.institution.jInstitutionSearchWrapper.closest('.js-e-checkout').length > 0){
                jQuery('.educations-delivery-validation').val(objInstitution.id);

                var objAddressMap = {
                    EcomOrderSchoolName: objInstitution.name,
                    EcomOrderSchoolCompany: objInstitution.company,
                    EcomOrderSchoolAddress: objInstitution.address,
                    EcomOrderSchoolAddress2: '',
                    EcomOrderSchoolZip: objInstitution.zip,
                    EcomOrderSchoolCity: objInstitution.city,
                    EcomOrderSchoolCountry: 'DK',
                    EcomOrderSchoolPhone: ''
                };
                e4.checkout.util.address.doMapping( objAddressMap );
                e4.checkout.order.update();
                e4.checkout.cart.update();
            } else if(olinoCaps.institution.jInstitutionSearchWrapper.closest('.js-olino-cap-configurator').length > 0){
                var arrEmbroideryNames = objInstitution.embroideryName.split(';'),
                    strEmbroideryName = objInstitution.embroideryName.split(';')[0];
                olinoCaps.institution.currentObjInstitution = objInstitution;
                olinoCaps.institution.clear();
                olinoCaps.institution.jInstitutionSearchWrapper.find( '.js-olino-schoolname-options' ).html('');
                if(arrEmbroideryNames.length > 1){
                    var objSchoolData = {
                        arrEmbroideryNames: arrEmbroideryNames,
                        userId: objInstitution.id
                    };
                    olinoCaps.institution.jInstitutionSearchWrapper.find('.js-olino-delete-deselect-school').trigger('click');
                    olinoCaps.institution.jInstitutionSearchWrapper.find( '.js-olino-schoolname-options' ).html( e4.handlebars.tmpl.schoolnameOptions( objSchoolData ) );
                } else {
                    olinoCaps.institution.setSchoolNameForEmbroidery(objInstitution.id, strEmbroideryName);
                }
            } else {
                jQuery('.js-olino-cap-school-userid').val(objInstitution.id);
            }
        },
        currentObjInstitution: null,
        setShippingInCheckout: function(objInstitution){
            console.log("here 1");
            var objData = {
                EcomOrderSchoolName: objInstitution.name,
                EcomOrderSchoolCompany: objInstitution.company,
                EcomOrderSchoolAddress: objInstitution.address,
                EcomOrderSchoolAddress2: '',
                EcomOrderSchoolZip: objInstitution.zip,
                EcomOrderSchoolCity: objInstitution.city,
                EcomOrderSchoolCountry: 'DK',
                EcomOrderSchoolPhone: ''
            };
            jQuery.ajax( {
                url: e4.settings.ecom.checkout.url,
                method: 'POST',
                dataType: 'json',
                cache: false,
                data: objData
            }, function ( jsonData ) {
                console.log(jsonData);
            } );
        },
        setSchoolNameForEmbroidery: function(intUserId, strEmbroideryName){
            olinoCaps.institution.jInstitutionSearchWrapper.find('.js-olino-embroidery-schoolname-container').removeClass('d-none');
            olinoCaps.institution.jInstitutionSearchWrapper.find('.js-olino-embroidery-schoolname').text(strEmbroideryName);
            olinoCaps.institution.jInstitutionSearchWrapper.find('#EcomOrderLineFieldInput_OrderLineEmbroiderySchoolName0').val(strEmbroideryName);
            jQuery('.js-olino-cap-school-userid').val(intUserId);
        }
    };

    olinoCaps.validationRules = {
        bind: function () {
            //jQuery.validator.addClassRules( 'js-validate-embroidery', {
            //    required: function ( domElement ) {
            //        var jElement = jQuery( domElement ),
            //            returnValue = false;
            //        if(jElement.val().length > 0){
            //            returnValue = !/[AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZzÆæØøÅåÄäÖöÜüββÁáÉéÓóÍíÚúÝýÑñ&\-.,_/ ]/i.test(jElement.val());
            //        }
            //        return returnValue;
            //    }
            //} );
        }
    };
}());
